<template>
	<a
		:href="url"
		:disabled="!url"
		target="_blank"
		class="link-button"
		:class="{ disabled: !url }"
		>
		<v-icon>far fa-eye</v-icon> <span>{{label}}</span>
	</a>
</template>

<script>
export default {
	props: {
		label: String,
		url: String,
	},
	data() {
		return {};
	},
	computed: {
		viewIcon() {
			if (!this.viewable) {
				return null;
			}
			return this.url ? "far fa-eye primary--text clickable" : "far fa-eye grey--text not-clickable";
		},
	},
	methods: {},
};
</script>
